namespace Ir.Components.Filters.QuarterFilter {

    interface IQuarterFilterViewModel {
        filter: Filter;
        selectBoxSettings: DevExpress.ui.dxSelectBox.Properties;
        selectBoxComponent: DevExpress.ui.dxSelectBox;
        nullButtonParams: Ir.Components.Filters.NullButton.INullButtonParams;
    }

    export function getViewModel(this: IQuarterFilterViewModel, params: IFilterParameterVM) {
        let self = this;
        this.filter = params.filter;

        let dataSource = [
            { id: "1", text: "Q1", subtext: "First Quarter" },
            { id: "2", text: "Q2", subtext: "Second Quarter" },
            { id: "3", text: "Q3", subtext: "Third Quarter" },
            { id: "4", text: "Q4", subtext: "Fourth Quarter" },
        ];

        this.filter.startDisplayCondition(dataSource.find(x => x.id == this.filter.startCondition())?.text ?? irSettings.nullText);

        this.selectBoxSettings = {
            dataSource: dataSource,
            disabled: ko.computed(function () {
                return self.filter.readOnly();
            }) as any,
            displayExpr: 'text',
            valueExpr: 'id',
            value: this.filter.startCondition,
            itemTemplate(data) {
                return `<div><span>${data.text}  <small>${data.subtext}</small></span></div>`;
            },
            onInitialized(e) {
                self.selectBoxComponent = e.component;
            },
            onValueChanged: function (data) {
                if (data.value !== null && data.previousValue !== data.value) {
                    self.filter.startCondition(data.value);
                    self.filter.startDisplayCondition(dataSource.find(x => x.id == data.value).text);
                    self.filter.publish();
                }
            }
        };

        this.nullButtonParams = {
            filter: this.filter,
            onItemClick(e) {
                if (self.filter.startCondition() === null) {
                    let firstQuarter = dataSource.length > 0 ? dataSource[0] : null;
                    self.filter.startCondition(firstQuarter?.id ?? null);
                    self.filter.startDisplayCondition(firstQuarter?.text ?? irSettings.nullText);
                }
                else {
                    self.filter.startCondition(null);
                    self.filter.startDisplayCondition(irSettings.nullText);
                }

                self.filter.publish();
                self.selectBoxComponent.element().focus();
            }
        };
    }
}